export class TermsOfUseTemplate {

    public TermsOfUseMessage: string;
    public AcknowledgementControlText: string;
    public AcknowledgmentYesLabel: string;
    public AcknowledgmentNoLabel: string;
    public SubmitButtonText: string;
    public LastUpdatedText: string;
    public TermsOfUseInstructions: string;
}